"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryAdapterEnhancer = exports.Error = exports.isAudio = exports.isVideo = exports.isImage = exports.createStorage = exports.Queue = void 0;
var Queue = /** @class */ (function () {
    function Queue(tasks, options) {
        this.index = -1;
        this.running = 0;
        this.canceled = false;
        this.tasks = tasks;
        this.concurrency = options.concurrency;
    }
    Queue.prototype.addTask = function (task) {
        this.tasks.push(task);
    };
    Queue.prototype.setTaskFullfilledHandler = function (callback) {
        this.onTaskFullfilled = callback;
    };
    Queue.prototype.setTaskRejectedHandler = function (callback) {
        this.onTaskRejected = callback;
    };
    Queue.prototype.setAllTaskFullfilledHandler = function (callback) {
        this.onAllTaskFullfilled = callback;
    };
    Queue.prototype.run = function () {
        var _this = this;
        if (this.running < this.concurrency &&
            !this.canceled &&
            this.index < this.tasks.length - 1) {
            this.running++;
            this.tasks[++this.index]()
                .then(function (data) {
                var _a;
                (_a = _this.onTaskFullfilled) === null || _a === void 0 ? void 0 : _a.call(_this, data);
                if (_this.index === _this.tasks.length - 1) {
                    _this.onAllTaskFullfilled();
                }
            })
                .catch(function (error) {
                var _a;
                (_a = _this.onTaskRejected) === null || _a === void 0 ? void 0 : _a.call(_this, error);
            })
                .finally(function () {
                _this.running > 0 && _this.running--;
                _this.run();
            });
            this.run();
        }
    };
    Queue.prototype.start = function () {
        this.index = -1;
        this.run();
    };
    Queue.prototype.cancel = function () {
        this.canceled = true;
    };
    Queue.prototype.resume = function () {
        this.canceled = false;
        this.run();
    };
    return Queue;
}());
exports.Queue = Queue;
var createStorage = function (key) {
    var ussKey = "USS_VOD_" + key;
    function get() {
        try {
            return JSON.parse(localStorage.getItem(ussKey));
        }
        catch (error) {
            return null;
        }
    }
    return {
        set: function (data) {
            try {
                localStorage.setItem(ussKey, JSON.stringify(data));
            }
            catch (error) {
                console.error(error);
            }
        },
        get: get,
        remove: function () {
            localStorage.removeItem(ussKey);
        }
    };
};
exports.createStorage = createStorage;
var isImage = function (file) {
    var ext = file.name.split('.').pop();
    return /^(jpg|jpeg|png|gif|bmp|webp)$/i.test(ext);
};
exports.isImage = isImage;
var isVideo = function (file) {
    var ext = file.name.split('.').pop();
    return /^(mp4|rmvb|mkv|flv|mpeg4|3gp|avi|mov|wmv|rm|mpg)$/i.test(ext);
};
exports.isVideo = isVideo;
var isAudio = function (file) {
    var ext = file.name.split('.').pop();
    return /^(mp3|aac)$/i.test(ext);
};
exports.isAudio = isAudio;
var Error = /** @class */ (function () {
    function Error(_a) {
        var _b = _a.code, code = _b === void 0 ? -1 : _b, message = _a.message, _c = _a.error, error = _c === void 0 ? null : _c, _d = _a.httpCode, httpCode = _d === void 0 ? null : _d;
        this.code = code;
        this.message = message;
        this.error = error;
        this.httpCode = httpCode;
    }
    return Error;
}());
exports.Error = Error;
var retryAdapterEnhancer = function (adapter, options) {
    var _a = options || {}, _b = _a.times, times = _b === void 0 ? 0 : _b, _c = _a.delay, delay = _c === void 0 ? 0 : _c;
    return function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, retryTimes, _b, retryDelay, __retryCount, request;
        return __generator(this, function (_c) {
            _a = config.retryTimes, retryTimes = _a === void 0 ? times : _a, _b = config.retryDelay, retryDelay = _b === void 0 ? delay : _b;
            __retryCount = 1;
            request = function () { return __awaiter(void 0, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 4]);
                            return [4 /*yield*/, adapter(config)];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            err_1 = _a.sent();
                            // 判断是否进行重试
                            if (!retryTimes || __retryCount >= retryTimes) {
                                return [2 /*return*/, Promise.reject(err_1)];
                            }
                            __retryCount++; // 增加重试次数
                            return [4 /*yield*/, new Promise(function (resolve) {
                                    setTimeout(resolve, retryDelay);
                                }).then(request)];
                        case 3: // 增加重试次数
                        // 延时处理
                        return [2 /*return*/, _a.sent()];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            return [2 /*return*/, request()];
        });
    }); };
};
exports.retryAdapterEnhancer = retryAdapterEnhancer;
